// ComingSoonTab — placeholder for tabs where the backend isn't implemented yet.
// Used for Controls, Actions, Events, and Compliance tabs.

import { Construction } from 'lucide-react'

interface ComingSoonTabProps {
  title: string
}

export function ComingSoonTab({ title }: ComingSoonTabProps) {
  return (
    <div className="flex h-48 items-center justify-center text-muted-foreground">
      <div className="space-y-2 text-center">
        <Construction className="mx-auto h-10 w-10 text-muted-foreground/40" />
        <p className="text-sm font-medium">{title}</p>
        <p className="text-xs">This feature is coming soon.</p>
      </div>
    </div>
  )
}
